import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import {
  useAppDispatch,
  useAppSelector,
  useDialogVisibilityHook
} from 'src/hooks';
import {
  AlertDialog,
  DialogResult,
  InformationDialog
} from 'src/components/analytics';
import { Grid, Button, AlertColor } from '@mui/material';
import { setScenario } from '../home/store/simulator-home-slice';
import { getAccessConfigForScenario } from '../home/store/simulator-home-async-thunks';
import { fetchScenarioDetails } from '../home/api/simulator-module-api';
import SnackbarComponent from '../innovation/components/snackbar/snackbar';
import { deleteSelectedScenarios } from './store/cluster-summary-slice';
import NoteDialogContainer from '../common/components/note/note-dialog-container';
import { setSourceId } from 'src/components/user/user/store/user-slice';
import { getSideNavBarData } from 'src/components/layout/appDrawer/app-drawer-slice-async-thunk';
import Storage from 'src/utils/storage/storage';
import { getSegmentDetails } from '../../landing/store/landing-slice';


interface IClusterSummaryFooterProps {
  selectedScenarios: { [key: string]: number | string }[];
}
export default function ClusterSummaryFooter({
  selectedScenarios
}: IClusterSummaryFooterProps) {
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();

  const [isConfirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [removeInputText, setRemoveInputText] = useState('');
  const {selectedSourceKey,
    sourceSelectedRowsMap
  } = useAppSelector((state) => state.clusterSummary);
  const navOptions = useAppSelector((state) => state.appDrawer.navOptions);
  const sourceId = useAppSelector((state) => state.user.source);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [snackbarContent, setSnackbarContent] = useState<{
    snackbarText: string;
    snackbarType: AlertColor;
  }>({
    snackbarText: '',
    snackbarType: 'success'
  });
   const getScenarioId = (): number[] =>
    selectedScenarios.map((row) => Number(row.scenario_id));

    const handleLoadScenario = (): void => {
      const [selectedScenario] = selectedScenarios;
      const sourceID = selectedSourceKey;
      appDispatch(setSourceId(selectedSourceKey));
      const sourceIdFromLocalStorage =
              Storage.getSourceId().source;
      appDispatch(getSideNavBarData({sourceID}))
      appDispatch(getSegmentDetails(sourceIdFromLocalStorage)).then(
              (segmentDetailsData) => {
                // storing the segment details in local storage
                Storage.setSegmentDetails(segmentDetailsData);
              }
            );
      fetchScenarioDetails(selectedSourceKey, selectedScenario?.scenario_id)
        .then((response) => response.data)
        .then((scenario) => {
          appDispatch(setScenario(scenario));
          navigate(`/srm/simulator/${scenario.pk_id}/planner`);
          appDispatch(
            getAccessConfigForScenario({
              scenarioId: scenario.pk_id,
              sourceId
            })
          );
        });    
  };

 const getPBILink = () => {
  // Flatten all children from navOptions
  const allItems = [
    ...navOptions.map(nav => nav.parent),
    ...navOptions.flatMap(nav => nav.children?.map(child => child.parent) || [])
  ];

  // Find the first item matching the filter by name or alias and has a non-empty embed_url
  const reportPage = allItems.find(
    (item: any) =>
      (item.name === "cluster_summary"|| item.alias === "Cluster Summary") &&
      item.embed_url
  );

  return reportPage?.embed_url || null;
};

 const scenarioIdsforProceed = (): string[] =>
    Object.values(sourceSelectedRowsMap)
        .flatMap(rows => 
            (rows as { [key: string]: string | number }[]).map(row => String(row.scenario_id))
        );
 
  const handleProceed =(): void =>{
    const baseUrl = getPBILink();
    if (!baseUrl) {
      setSnackbarContent({
        snackbarText: 'No Power BI report available for this selection.',
        snackbarType: 'error'
      });
      setIsSnackbarOpen(true);
      return;
    }
    const scenarioIds = scenarioIdsforProceed();
    const fullUrl = baseUrl.replace('{scenario_id}', scenarioIds.join(','));
    // Navigate to the Power BI report with the constructed
    navigate('/powerbi-embed?pbiUrl=' + encodeURIComponent(fullUrl));
  }

   const handleDeleteScenario = (): void => {
    setConfirmationDialogOpen(true);
  };

   const handleConfirmationDialogClose = (result: DialogResult, inputText?:string) => {
    if (result === DialogResult.YES &&  inputText?.trim()) {
      appDispatch(
        deleteSelectedScenarios({ scenarioIds: getScenarioId(),
          sourceId: selectedSourceKey }) 
      );
    }
    setConfirmationDialogOpen(false);
  };

  return (
    <Grid 
     container
      sx={{
        position: 'sticky',
        bottom: 0,
        backgroundColor: (theme) => theme.palette.common.white,
        padding: (theme) => theme.spacing(1),
        zIndex: 2
      }}>

        <Grid container justifyContent="right">
            
            <Grid item>
                <Button variant="contained"
                 color="primary" 
                 disabled={selectedScenarios.length === 0} 
                 onClick={handleLoadScenario}>
                Load Scenario
                </Button>
                <Button sx={{ ml: 1 }} variant= "contained"
                disabled={scenarioIdsforProceed().length === 0}
                onClick= {handleProceed}>
                  Proceed</Button>
            </Grid>
            </Grid>
        <NoteDialogContainer 
        sourceId={selectedSourceKey}
        isScenarioManager= {false}
        />
        <AlertDialog
        closeHandler={handleConfirmationDialogClose}
        isDialogOpen={isConfirmationDialogOpen}
        message='Are you sure you want to delete the selected scenarios?'
        title='Info'
      />
      <AlertDialog
        closeHandler={handleConfirmationDialogClose}
        isDialogOpen={isConfirmationDialogOpen}
        message='Are you sure you want to delete the selected scenarios?'
        title='Info'
      />
       <SnackbarComponent
        isSnackbarOpen={isSnackbarOpen}
        setSnackbar={setIsSnackbarOpen}
        snackbarText={snackbarContent.snackbarText}
        snackbarType={snackbarContent.snackbarType}
        />
      {/* <RemoveConfirmationDialog
        open={isConfirmationDialogOpen}
        inputText={removeInputText}
        onInputChange= {setRemoveInputText}
        onClose={handleConfirmationDialogClose}/> */}
    </Grid>
  );
}